import "./App.css";
import HomePage from "./page/HomePage";
import GameIframe from "./components/games/GameIframe";
import FrenPage from "./page/FrenPage";
import Layout from "./components/Layout";
import { Routes, Route, BrowserRouter } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="frens" element={<FrenPage />} />
          </Route>
          <Route path="end_play" element={<FrenPage />} />
          <Route path="game" element={<GameIframe />} />
          <Route path="*" element={<h1>404 Page no Found</h1>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
